function sortByQuery() {
  const gantt = window.to_use_react_gantt;
  if (gantt.toOrderByQuery) {
    gantt.sort(eval(gantt.toOrderByQuery));
  }
}

export { sortByQuery };
